import MapElementProps from "../MapElementProps";
import { LocationInfo, selectUserLocation } from "../../../redux/features/location/slice";
import { useAppSelector } from "../../../redux/hooks";
import MapIControl from "./MapIControl";
import { track } from "../../../helpers/analytics";
import { t } from "../../../i18n";

const GoToUserLocationControl = ({map}: MapElementProps) => {
    const userLocation: LocationInfo | undefined = useAppSelector(selectUserLocation);

    return (
        <MapIControl map={map!} position='top-right' doShow={() => true}>
            <button className="mapboxgl-ctrl-geolocate"
                    style={{ width: '39px', height: '39px' }}
                    type="button"
                    aria-label={t('web.map.findMyLocation')}
                    onClick={() => {
                        track('goto_user_location_clicked', { has_location: !!userLocation?.coordinate });
                        if (userLocation?.coordinate && map) {
                            map.panTo([userLocation.coordinate.longitude, userLocation.coordinate.latitude]);
                        }
                    }}
            >
                <span className="mapboxgl-ctrl-icon" aria-hidden="true" title={t('web.map.findMyLocation')}/>
            </button>
        </MapIControl>
    );
};

export default GoToUserLocationControl;
